import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get as _get } from 'lodash';

import LoadingModal from '../components/Common/LoadingModal';

class LoadingModalContainer extends Component {
    render() {
        if (!this.props.message)
            return null;

        return (
            <LoadingModal { ...this.props } />
        );
    }
}

function mapStateToProps(state) {
    const { loading } = state.environment;

    return {
        message: _get(loading, `message`),
        graphic: _get(loading, `graphic`),
    };
}

export default connect(mapStateToProps)(LoadingModalContainer);



// WEBPACK FOOTER //
// ./scripts/containers/LoadingModalContainer.jsx